/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Alternatives_Section_DescriptionInputs */

const en_directory_taxonomy_alternatives_section_description = /** @type {(inputs: Directory_Taxonomy_Alternatives_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each destination starts from an existing Seek AI product profile and keeps the comparison grounded in published directory data.`)
};

const zh_directory_taxonomy_alternatives_section_description = /** @type {(inputs: Directory_Taxonomy_Alternatives_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个入口都从现有 Seek AI 产品页出发，让比较基于目录中已经发布的数据。`)
};

/**
* | output |
* | --- |
* | "Each destination starts from an existing Seek AI product profile and keeps the comparison grounded in published directory data." |
*
* @param {Directory_Taxonomy_Alternatives_Section_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_alternatives_section_description = /** @type {((inputs?: Directory_Taxonomy_Alternatives_Section_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Alternatives_Section_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_alternatives_section_description(inputs)
	return zh_directory_taxonomy_alternatives_section_description(inputs)
});
export { directory_taxonomy_alternatives_section_description as "directory.taxonomy.alternatives.section_description" }